/* Delegated swatch click — swap card image, toggle pressed state.
   Works for any product-card on the page (arrivals, collection, related). */
(() => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-card__swatch[data-swatch]');
    if (!btn) return;
    e.preventDefault();
    const card = btn.closest('.product-card');
    if (!card) return;
    const img = card.querySelector('[data-card-img]');
    const newSrc = btn.getAttribute('data-image');
    const variantId = btn.getAttribute('data-variant-id');
    if (img && newSrc) img.src = newSrc;
    card.querySelectorAll('.product-card__swatch').forEach((s) =>
      s.setAttribute('aria-pressed', s === btn ? 'true' : 'false')
    );
    if (variantId) {
      const qa = card.querySelector('[data-quick-add]');
      if (qa) qa.setAttribute('data-variant-id', variantId);
    }
  });
})();
